import { AfterViewInit, Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CoreValidators } from '../../../form/validators';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ValidationConfigComponent),
    multi: true
};

@Component({
    selector: 'chassis-validation-config',
    templateUrl: './validation-config.component.html',
    styleUrls: ['./validation-config.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ValidationConfigComponent extends InputComponent implements OnInit, AfterViewInit {

    @Input() field;

    public rules               = [];
    public availableValidators = [];

    /**
     * Construct
     *
     * @param injector
     */
    constructor(protected injector: Injector) {
        super(injector);

        this.availableValidators = CoreValidators;
    }

    public ngOnInit() {

        this.availableValidators = this.availableValidators.filter(validator => this.field.settings.available_validations.indexOf(validator.name) !== -1);

    }

    public ngAfterViewInit() {

        if (typeof this.val === 'object') {
            for (const validator in this.val) {

                const availableValidator = this.availableValidators.find(coreValidator => coreValidator.name === validator);

                this.rules.push({
                    validation: validator,
                    parameters: this.val[validator],
                    parameter_type: availableValidator.parameter_type
                });
            }
        }
    }

    public selectValidation(rule) {

        const validator = this.availableValidators.find(coreValidator => coreValidator.name === rule.validation);

        rule.parameter_type = validator.parameter_type;

        this.updateValue();

    }

    public addRule() {
        this.rules.push({
            validation: '',
            parameters: '',
            parameter_type: null
        });
        this.updateValue();
    }

    public deleteRule(index) {
        this.rules.splice(index, 1);
        this.updateValue();
    }

    public updateValue() {

        const validationObject = {};

        this.rules.forEach(rule => {
            validationObject[rule.validation] = rule.parameters;
        });

        this.val = validationObject;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/validation-config/validation-config.component.ts